/* eslint-disable import/no-anonymous-default-export */
import moment from "moment-timezone";
import { AppStateUserProfile, ProfileState, UserProfileResponce } from ".";
import { navigatorToUs, parseFromApi } from "../../utils/Languages";
import { StorageHelper, StorageType } from "../../utils/StorageHelper";
import {
  AUTHENTICATION,
  IAddEmailEndSuccess,
  IAddPhoneEndSuccess,
  IChangeRegisterLanguage,
  IEditUsernameEndSuccess,
} from "../auth/types";
import { RoleType } from "./";
import {
  IChangeLanguageSuccess,
  IChangeNotificationSockets,
  IEditUserAvatarSuccess,
  IGetUserProfileBySocket,
  ISetDataFromAuth,
  ISetUserProfileIdFromToken,
  ISetUserProfileRoleFromToken,
  IUserProfileChangeMonitorNodeAction,
  IUserProfileChangeSelectedENDNodeAction,
  IUserProfileChangeSelectedNdeAction,
  IUserProfileDeleteNodeActionBySockets,
  IUserProfileSuccessAction,
  USER_PROFILE,
  UserProfileActionTypes,
} from "./types";
import { USERS } from "../users/types";

const selectedNode = (userId: string): number | undefined => {
  return (
    Number.parseInt(
      StorageHelper.instance.GetItem(StorageType.SELECTED_NODE_ID, userId)
    ) || undefined
  );
};

const selectedENDNode = (userId: string): number | undefined => {
  return (
    Number.parseInt(
      StorageHelper.instance.GetItem(StorageType.SELECTED_END_NODE_ID, userId)
    ) || undefined
  );
};

const selectedMonitorNode = (userId: string): number | undefined => {
  return (
    Number.parseInt(
      StorageHelper.instance.GetItem(StorageType.MONITOR_NODE_ID, userId)
    ) || undefined
  );
};

const initialState: AppStateUserProfile = {
  id: undefined,
  picture: undefined,
  roleName: undefined,
  roleNameList: undefined,
  email: undefined,
  baseNodeId: undefined,
  profileState: undefined,
  providers: [],
  status: undefined,
  language: navigatorToUs(),
  firstName: undefined,
  lastName: undefined,
  gender: undefined,
  dateOfBirth: undefined,
  isLoading: undefined,
  selectedNodeId: undefined,
  endNodeId: undefined,
  monitorNodeId: undefined,
  notifications: undefined,
  idetityProviders: [],
  isLoadingEdit: undefined,
};

const reducer = (
  state = initialState,
  action: UserProfileActionTypes
): AppStateUserProfile => {
  switch (action.type) {
    case USER_PROFILE.SET_USER_ROLE: {
      const role = (action as ISetUserProfileRoleFromToken).payload;
      return {
        ...state,
        roleName: role,
        roleNameList: [role],
      };
    }
    case USER_PROFILE.SET_USER_ID: {
      const id = (action as ISetUserProfileIdFromToken).payload;
      return {
        ...state,
        id: id,
        selectedNodeId: selectedNode(id),
        monitorNodeId: selectedMonitorNode(id),
        endNodeId: selectedENDNode(id),
      };
    }
    case USER_PROFILE.EDIT_PROFILE_REQUEST:
    case USER_PROFILE.EDIT_AVATAR_REQUEST: {
      return { ...state, isLoadingEdit: true };
    }
    case USER_PROFILE.REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case USER_PROFILE.SUCCESS: {
      const data: UserProfileResponce = (action as IUserProfileSuccessAction)
        .payload;
      const { selectedNodeId, endNodeId, monitorNodeId } = userSelectedNodes(
        data.baseNodeId,
        data.id
      );
      let roleCopy = data.roleName;
      const roleArr = [data.roleName];
      if (Array.isArray(data.roleName)) {
        roleCopy = data.roleName.find((el) => el !== RoleType.DEV);
      }
      const pic =
        data?.picture?.indexOf("s.gravatar") === -1 &&
        data?.picture?.indexOf("cdn.auth0") === -1
          ? data.picture
          : "";
      const langFixed = parseFromApi(data.language);
      moment.locale(langFixed);
      return Object.assign({}, state, {
        ...data,
        roleName: roleCopy,
        roleNameList: roleArr,
        isLoading: false,
        picture: pic,
        selectedNodeId,
        monitorNodeId,
        endNodeId,
        language: langFixed,
      });
    }
    case USER_PROFILE.DELETE_USER_AVATAR_SUSSESS: {
      return { ...state, picture: "", isLoadingEdit: false };
    }
    case USER_PROFILE.EDIT_PROFILE_SUSSESS:
    case USER_PROFILE.EDIT_PROFILE_FAILURE:
    case USER_PROFILE.DELETE_USER_AVATAR_FAILURE:
    case USER_PROFILE.EDIT_AVATAR_FAILURE: {
      return { ...state, isLoadingEdit: false };
    }

    case USER_PROFILE.GET_PROFILE_BY_SOCKET: {
      const data = (action as IGetUserProfileBySocket).payload;
      if (data.userId === state.id)
        return { ...state, ...data, picture: state.picture };
      return state;
    }

    case USER_PROFILE.EDIT_AVATAR_SUSSESS: {
      const data = (action as IEditUserAvatarSuccess).payload;
      const pic =
        data?.indexOf("s.gravatar") === -1 && data?.indexOf("cdn.auth0") === -1
          ? data
          : "";
      return { ...state, picture: pic, isLoadingEdit: false };
    }

    case USER_PROFILE.FAILURE: {
      return { ...state, isLoading: false };
    }
    case USER_PROFILE.CHANGE_SELECTED_NODE_ID: {
      const data: number = (action as IUserProfileChangeSelectedNdeAction)
        .payload;
      StorageHelper.instance.SaveItem(
        StorageType.SELECTED_NODE_ID,
        data,
        state.id
      );
      return { ...state, selectedNodeId: data };
    }
    case USER_PROFILE.CHANGE_SELECTED_END_NODE_ID: {
      const data: number = (action as IUserProfileChangeSelectedENDNodeAction)
        .payload;
      StorageHelper.instance.SaveItem(
        StorageType.SELECTED_END_NODE_ID,
        data,
        state.id
      );
      return { ...state, endNodeId: data };
    }
    case USER_PROFILE.CHANGE_MONITOR_NODE_ID: {
      const data: number = (action as IUserProfileChangeMonitorNodeAction)
        .payload;
      StorageHelper.instance.SaveItem(
        StorageType.MONITOR_NODE_ID,
        data,
        state.id
      );
      return { ...state, monitorNodeId: data };
    }
    case USER_PROFILE.DELETE_NODE_BY_SOCKETS: {
      const allPossibleIDs = (action as IUserProfileDeleteNodeActionBySockets)
        .payload;

      let newSelected = state.selectedNodeId;
      let newEndSelected = state.endNodeId;
      let newMon = state.monitorNodeId;
      if (allPossibleIDs.indexOf(state.selectedNodeId) !== -1) {
        StorageHelper.instance.SaveItem(
          StorageType.SELECTED_NODE_ID,
          state.baseNodeId,
          state.id
        );
        newSelected = state.baseNodeId;
      }
      if (allPossibleIDs.indexOf(state.endNodeId) !== -1) {
        newEndSelected = undefined;
        StorageHelper.instance.SaveItem(
          StorageType.SELECTED_END_NODE_ID,
          newEndSelected,
          state.id
        );
      }
      if (allPossibleIDs.indexOf(state.monitorNodeId) !== -1) {
        newMon = undefined;
        StorageHelper.instance.SaveItem(
          StorageType.MONITOR_NODE_ID,
          newMon,
          state.id
        );
      }
      return {
        ...state,
        endNodeId: newEndSelected,
        selectedNodeId: newSelected,
        monitorNodeId: newEndSelected,
      };
    }

    case USER_PROFILE.CHANGE_LANGUAGE_SUSSESS: {
      const newLang = (action as IChangeLanguageSuccess).payload;
      return { ...state, language: newLang };
    }

    case USER_PROFILE.CHANGE_NOTIFICATION_BY_SOCKETS: {
      const { userId, value } = (action as IChangeNotificationSockets).payload;
      if (userId === state.id) return { ...state, notifications: value };
      return state;
    }

    case AUTHENTICATION.CHANGE_LANGUAGE: {
      return {
        ...state,
        language: (action as IChangeRegisterLanguage).payload,
      };
    }
    case USER_PROFILE.SET_USER_DATA_FROM_AUTH: {
      const { baseNodeId, role, profileState, userId, idetityProviders } = (
        action as ISetDataFromAuth
      ).payload;
      const profState = profileState
        ? profileState === 2
          ? ProfileState.Completed
          : profileState === 0
          ? ProfileState.NeedContactInfo
          : ProfileState.NeedOrganizationInfo
        : ProfileState.NeedContactInfo;
      const { selectedNodeId, endNodeId, monitorNodeId } = userSelectedNodes(
        baseNodeId,
        userId
      );
      return {
        ...state,
        baseNodeId: baseNodeId,
        roleName: role as RoleType,
        id: userId,
        profileState: profState,
        selectedNodeId,
        endNodeId,
        monitorNodeId,
        idetityProviders,
      };
    }
    case AUTHENTICATION.SIGN_UP_NEW_PASSWORLESS_SUCCESS: {
      const old = state.profileState;
      return {
        ...state,
        profileState:
          old === ProfileState.NeedContactInfo &&
          state.roleName === RoleType.OWNER
            ? ProfileState.NeedOrganizationInfo
            : ProfileState.Completed,
      };
    }

    case AUTHENTICATION.ADD_PHONE_END_SUCCESS: {
      const { phone } = (action as IAddPhoneEndSuccess).payload;
      const ident = [...state.idetityProviders];
      ident.push({ name: "sms", username: phone });
      return { ...state, idetityProviders: ident };
    }
    case AUTHENTICATION.ADD_EMAIL_END_SUCCESS: {
      const { email } = (action as IAddEmailEndSuccess).payload;
      const ident = [...state.idetityProviders];
      ident.push({ name: "auth0", username: email });
      return { ...state, idetityProviders: ident };
    }
    case AUTHENTICATION.EDIT_USERNAME_END_SUCCESS: {
      const { type, username } = (action as IEditUsernameEndSuccess).payload;
      const ident = [...state.idetityProviders];
      ident.splice(
        ident.findIndex((el) => el.name === type),
        1,
        { name: type, username }
      );
      return { ...state, idetityProviders: ident };
    }
    case USERS.GET_USERS_PICTURE_SUCCESS: {
      const data = action.payload;
      let newPic = undefined;
      data.map((el) => {
        if (el?.userId !== state.id) return null;
        newPic = el?.picture;
        return null;
      });
      if (newPic) {
        return {
          ...state,
          picture: newPic,
        };
      }
      return state;
    }
    default:
      return state;
  }
};

const userSelectedNodes = (baseNodeId: number, id: string) => {
  const oldBaseNode = StorageHelper.instance.GetItem(
    StorageType.BASE_END_NODE_ID,
    id
  );
  let oldSelected = selectedNode(id);
  let oldendNodeId = selectedENDNode(id);

  if (oldBaseNode !== baseNodeId.toString()) {
    oldSelected = undefined;
    oldendNodeId = undefined;
    StorageHelper.instance.ClearItem(StorageType.SELECTED_END_NODE_ID);
    StorageHelper.instance.ClearItem(StorageType.SELECTED_NODE_ID);
  }
  StorageHelper.instance.SaveItem(StorageType.BASE_END_NODE_ID, baseNodeId, id);
  return {
    selectedNodeId: oldSelected,
    monitorNodeId: selectedMonitorNode(id)
      ? selectedMonitorNode(id)
      : oldendNodeId,
    endNodeId: oldendNodeId,
  };
};
export default reducer;
